import { json, type MetaFunction } from '@remix-run/node'
import { Link, useLoaderData } from '@remix-run/react'
import { useState } from 'react'
import { GeneralErrorBoundary } from '#app/components/error-boundary.tsx'
import { Page, PageContent, PageTitle } from '#app/components/page.tsx'
import { Button } from '#app/components/ui/button.tsx'
import { Icon } from '#app/components/ui/icon.tsx'
import { Input } from '#app/components/ui/input.tsx'
import { prisma } from '#app/utils/db.server.ts'
import { filterRecipes } from '#app/utils/recipe.ts'
import { useOptionalUser } from '#app/utils/user.ts'

export const meta: MetaFunction = () => [
	{ title: 'Denman Dines' },
	{
		name: 'description',
		content: 'All my favorite recipes in a one stop shop.',
	},
]

export async function loader() {
	const recipes = await prisma.recipe.findMany({
		select: {
			name: true,
			slug: true,
		},
		orderBy: { name: 'asc' },
	})
	return json({ recipes })
}

export default function RecipesIndexRoute() {
	const data = useLoaderData<typeof loader>()
	const user = useOptionalUser()

	const [filter, setFilter] = useState('')

	return (
		<Page>
			<PageTitle className="justify-between">
				<h1 className="text-h4">Recipes</h1>

				{user && (
					<Button asChild size="sm" variant="ghost">
						<Link to={`/recipes/new`} aria-label="New" className="gap-2">
							<Icon name="plus" size="sm" />
							<span className="">New</span>
						</Link>
					</Button>
				)}
			</PageTitle>
			<PageContent>
				<Input
					placeholder="Search"
					value={filter}
					onChange={(e) => setFilter(e.target.value)}
				/>
				<ul>
					{filterRecipes(filter, data.recipes).map((recipe) => (
						<li key={recipe.slug} className="mb-2">
							<Button asChild variant="link" className="text-md">
								<Link
									to={`/recipes/${recipe.slug}`}
									prefetch="intent"
									className="gap-2"
								>
									{recipe.name} <Icon name="arrow-right" />
								</Link>
							</Button>
						</li>
					))}
				</ul>
			</PageContent>
		</Page>
	)
}

export function ErrorBoundary() {
	return <GeneralErrorBoundary />
}
